import NeedHelpBanner from "@core-components/help-banner/NeedHelpBanner";
import ReviewCarousel from "@core-components/reviews/ReviewCarousel";
import reviews from "@core-components/reviews/defaultReviews";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { useAppRegion } from "@hooks/region/useAppRegion";
import { Stack } from "@mantine/core";
import LoLFAQ from "@modules/lol/faq/LoLFAQ";
import SEO from "@modules/seo/SEO";
import type React from "react";
import { ProductDetailsHero } from "../components/ProductDetailsHero";
import { ProductDetailsInfo } from "../components/ProductDetailsInfo";
import { ProductDetailsMain } from "../components/ProductDetailsMain";
import { useLolProductDetails } from "../hooks/useLolProductDetails";

const LolProductDetailsPage: React.FC = () => {
  const { t } = useAppTranslation();
  const { product, handleBuyModal, onRegionChange } = useLolProductDetails();
  const { currentRegion } = useAppRegion();

  return (
    <>
      <div>
        <SEO
          description={t(`${product?.i18nKey}.metadata.description`, {
            region: currentRegion.toUpperCase(),
          })}
          title={t(`${product?.i18nKey}.metadata.title`, {
            region: currentRegion.toUpperCase(),
          })}
        />
        <ProductDetailsHero product={product} />
        <Stack
          align="center"
          className="mt-16 w-full gap-y-16 bg-primary-background md:px-3"
        >
          <ProductDetailsMain
            handleRegionChange={onRegionChange}
            region={currentRegion}
            onBuy={handleBuyModal}
            product={product}
          />
          <ProductDetailsInfo product={product} />
          <NeedHelpBanner />
          <ReviewCarousel reviews={reviews} />
          <LoLFAQ />
        </Stack>
      </div>
    </>
  );
};

export default LolProductDetailsPage;
